import { Box, Flex, customStyled } from '@mafc/trolly';

export const Heading = customStyled(Box)(
  ({ theme: { space, fontSizes, fontWeights, colors } }) => ({
    marginBottom: space[3],
    fontWeight: fontWeights[8],
    fontSize: fontSizes[3],
    color: colors.black,
  })
);

export const IconWrapper = customStyled(Box)(({ theme: { space } }) => ({
  marginRight: space[3],
}));

export const SecurePaymentsLogo = customStyled(Flex)(({ theme: { space } }) => ({
  alignItems: 'center',
  flexDirection: 'column',
  marginBottom: space[4],
}));
